<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>
        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="3">
                <CInput
                  label="Title"
                  invalid-feedback="Title should be filled"
                  required
                  v-model="$v.promotionForm.title.$model"
                  :is-valid="!$v.promotionForm.title.$invalid"
                  :readonly="isReadonly"
                />
              </CCol>
              
            </CRow>
            <br>
            <CRow>
              <CCol sm="9">
                <label for="nik">Description</label>
                <quill-editor
                  style="height: 200px; margin-bottom: 70px"
                  :content="content"
                  :options="editorOption"
                  v-model="$v.promotionForm.description.$model"
                  @change="onEditorChange($event)"
                  :disabled="isReadonly"
                >
                </quill-editor>
                <div
                  v-if="$v.promotionForm.description.$invalid"
                  class="invalid-feedback-custom"
                >
                  Description harus di isi.
                </div>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              :disabled="$v.promotionForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab active>
            <template slot="title">Images</template>
            <UploadImage
              :promotion="promotionForm"
              :promotion-status="'2'"
            ></UploadImage>
          </CTab>
          <CTab>
            <template slot="title">Images On Page</template>
            <UploadImageOnPage
              :promotion="promotionForm"
              :promotion-status="'2'"
            ></UploadImageOnPage>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../templates/Loading";

import { required } from "vuelidate/lib/validators";
import UploadImage from "./tabs/UploadImage";
import UploadImageOnPage from "./tabs/UploadImageOnPage";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "News Detail",
  components: { GlobalTable, Loading, UploadImage, quillEditor, UploadImageOnPage },
  data() {
    return {
      title: "News Detail",
      promotionForm: tableInterfaces.promotion,
      isLoading: false,
      activeTab: 0,
      statusPromotion: null,
      voucherTypeList: [
        { value: "1", text: "Diskon Harga" },
        { value: "2", text: "Diskon Persen" },
      ],
      statusList: [
        { value: "1", text: "Active" },
        { value: "2", text: "Disabled" },
      ],
      redirectList: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" },
      ],
      content: "",
      editorOption: {}, // data quill
    };
  },
  validations: {
    promotionForm: {
      title: { required },
      description: {required}
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isReadonly: function () {
      return this.statusPromotion === "1" ? true : false;
    },
  },
  methods: {
    init: function (id) {
      this.getPromotionDetail(id);
    },
    getPromotionDetail: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/news/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.promotionForm = response.data.data;
            this.statusPromotion = this.promotionForm.status;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.promotion) {
        tableInterfaces.promotion[i] = null;
      }
      this.promotionForm = tableInterfaces.promotion;
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah promotion ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/news/update", this.promotionForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah promotion detail",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah promotion detail error");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.promotionForm.description = html;
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
